import { render, staticRenderFns } from "./GiftCardsExport.vue?vue&type=template&id=fb642350&scoped=true"
import script from "./GiftCardsExport.vue?vue&type=script&lang=js"
export * from "./GiftCardsExport.vue?vue&type=script&lang=js"
import style0 from "./GiftCardsExport.vue?vue&type=style&index=0&id=fb642350&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb642350",
  null
  
)

export default component.exports